import { textColor } from 'common/theme'
import styled from 'styled-components'

export const StyledAuctionTimeRemaining = styled.div<{ color?: string }>`
  color: ${({ color }) => color || textColor};
  font-size: 1.2rem;
  font-weight: 500;
`
